import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Pagination.css';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaTrashAlt, FaFileExport,FaEdit} from 'react-icons/fa';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import { ToastContainer, toast } from 'react-toastify';
import * as XLSX from 'xlsx';

const ViewDeliveryAgentEarnings = () => {
    const navigate = useNavigate();
    const epicxTenantId = localStorage.getItem('epicxTenantId');
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const AuthorizationToken = localStorage.getItem('token');
    const [data, setData] = useState([]); 
    const [originalData, setOriginalData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedItems, setSelectedItems] = useState([]);
    const [loading, setLoading] = useState(true); 
    const [error, setError] = useState(null); 

    // Fetch data from API
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${BASE_URL}/deliveryVendor/api/deliveryAgentEarnings/${epicxTenantId}/earnings`,
                    {
                        headers: {
                            Authorization: `Bearer ${AuthorizationToken}`,
                          },
                        }
                );
                const result = await response.json();
                if (response.ok) {
                    setData(result.data);
                    setOriginalData(result.data); 
                } else {
                    setError(result.message || 'Failed to fetch data');
                }
            } catch (err) {
                setError('Error fetching data: ' + err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // search 
    const handleSearch = (value) => {
        setSearchTerm(value.toLowerCase());
        if (value.trim() === '') {
            setData(originalData);  
        } else {
            const filteredData = originalData.filter((item) =>
                Object.keys(item).some((key) =>
                    item[key].toString().toLowerCase().includes(value.toLowerCase())
                )
            );
            setData(filteredData);
        }
        setCurrentPage(1); 
    };

    //sorting 
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        setData((prevData) => {
            return [...prevData].sort((a, b) => {
                if (a[key] < b[key]) {
                    return direction === 'asc' ? -1 : 1;
                }
                if (a[key] > b[key]) {
                    return direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        });
    };

    //select all items for actions like delete
    const handleSelectAll = () => {
        if (selectedItems.length === data.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(data.map(item => item._id));
        }
    };

    //  selecting individual items
    const handleSelectItem = (_id) => {
        if (selectedItems.includes(_id)) {
            setSelectedItems(selectedItems.filter(item => item !== _id));
        } else {
            setSelectedItems([...selectedItems, _id]);
        }
    };

    // delete 
    const handleDelete = async () => {
        if (selectedItems.length > 0) {
            try {
                const confirmDelete = window.confirm(
                    `Are you sure you want to delete ${selectedItems.length} item(s)?`
                );
                if (!confirmDelete) return;
    
                const promises = selectedItems.map(async (itemId) => {
                    const response = await fetch(
                        `${BASE_URL}/deliveryVendor/api/deliveryAgentEarnings/${epicxTenantId}/earnings/${itemId}`,
                        {   headers: {
                                Authorization: `Bearer ${AuthorizationToken}`,
                              },
                            method: "DELETE",
                        }
                    );
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(
                            `Failed to delete item with ID ${itemId}: ${errorData.message}`
                        );
                    }
                });
    
                await Promise.all(promises);
                toast.success("Selected items deleted successfully.");
                console.log("Deleted items:", selectedItems);
                setData((prevData) => prevData.filter(item => !selectedItems.includes(item._id)));
                setSelectedItems([]); 
            } catch (error) {
                console.error("Error deleting items:", error);
                toast.error("Failed to delete selected items. Please try again.");
            }
        } else {
            toast.error("No items selected for deletion.");
        }
    };

    // edit
    const handleEdit = () => {
        if (selectedItems.length === 1) {
            const selectedItem = data.find(item => item._id === selectedItems[0]); 
            if (selectedItem) {
                console.log('Edit this item:', selectedItem);
                navigate(`/update-earnings/${selectedItem._id}`); 
            } else {
                console.error('Selected item not found in data');
                toast.error('Error: Selected item not found.');
            }
        } else {
            toast.error("Please select exactly one Independent Delivery to edit");
        }
    };

    // export 
    const handleExport = () => {
    const dataToExport = selectedItems.length > 0 
        ? data.filter(item => selectedItems.includes(item._id)) 
        : data; 
    const exportData = dataToExport.map(item => ({
        agentId: item.agentId,
        agentName: item.agentName,
        totalDeliveries: item.totalDeliveries,
        totalEarnings: item.totalEarnings,
        deductions: item.deductions,
        netEarnings: item.netEarnings,
        bonusEarnings: item.bonusEarnings,
        paymentStatus: item.paymentStatus,
        date:item.date,
        comments:item.comments,
        createdAt:item.createdAt
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "DeliveryAgentEarnings");
    XLSX.writeFile(wb, 'Delivery_Agent_Earnings.xlsx');
};    

    // Pagination 
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    return (
        <>
            <Sidebar />
            <div style={{ height: '92vh', overflowY: 'auto', width: '100%' }}>
                <div style={{ height: '100vh', overflowY: 'auto', width: '100%', padding: '15px' }}>
                    <div className='d-flex justify-content-between mb-3 align-items-center'>
                        <h4 className='mb-0'>Delivery Agent Earnings List</h4>
                        <div className='d-flex align-items-center'>
                            <div className='me-3'>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search..."
                                    style={{ borderRadius: '300px' }}
                                    value={searchTerm}
                                    onChange={(e) => handleSearch(e.target.value)}
                                />
                            </div>
                            <button
                                className="btn me-3"
                                style={{ backgroundColor: '#31a87e', color: 'white' }}
                                onClick={() => navigate('/add-delivery-earnings')}
                            >
                                <FaPlus className="me-2" /> Add Agent Earnings
                            </button>
                            <Dropdown>
                                <Dropdown.Toggle
                                    className="btn"
                                    style={{ backgroundColor: '#31a87e', color: 'white', border: 'none' }}
                                >
                                    Action
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={handleDelete} disabled={selectedItems.length === 0}>
                                        <FaTrashAlt className="me-2" /> Delete
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={handleEdit} disabled={selectedItems.length !== 1}>
                                        <FaEdit className="me-2" /> Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={handleExport}>
                                        <FaFileExport className="me-2" /> Export
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                    </div>
                    {loading && <div>Loading...</div>}
                    {error && <div style={{ color: 'red' }}>{error}</div>}
                    {!loading && !error && (
                        <div className="card">
                            <div className="card-header" style={{ height: '65px' }}>
                                <div>
                                    <input
                                        type="checkbox"
                                        checked={selectedItems.length === data.length}
                                        onChange={handleSelectAll}
                                    />
                                </div>
                                {['agentId', 'agentName', 'totalDeliveries', 'totalEarnings', 'deductions', 'netEarnings', 'bonusEarnings', 'paymentStatus'].map((key) => (
                                    <div key={key} onClick={() => handleSort(key)}>{key}</div>
                                ))}
                            </div>
                            <div className="card-body table-card-body" style={{ height: '400px' }}>
                                {currentData.map((item) => (
                                    <div key={item._id} className={`row ${selectedItems.includes(item._id) ? 'selected-row' : ''}`}>
                                        <div>
                                            <input
                                                type="checkbox"
                                                checked={selectedItems.includes(item._id)}
                                                onChange={() => handleSelectItem(item._id)}
                                            />
                                        </div>
                                        <div>{item.agentId}</div>
                                        <div>{item.agentName}</div>
                                        <div>{item.totalDeliveries}</div>
                                        <div>{item.totalEarnings}</div>
                                        <div>{item.deductions}</div>
                                        <div>{item.netEarnings}</div>
                                        <div>{item.bonusEarnings}</div>
                                        <div>{item.paymentStatus}</div>
                                    </div>
                                ))}
                            </div>
                            <div className="card-footer">
                                <div className="d-flex justify-content-between align-items-center">
                                    {/* Count */}
                                    <span style={{ marginRight: '10px', fontSize: '14px', fontWeight: '' }}>
                                        {`Total Delivery Agent Earnings: ${data.length}`}
                                    </span>

                                    {/* Pagination */}
                                    <div className="pagination d-flex justify-content-center align-items-center">
                                        <nav>
                                            <ul className="pagination mb-0">
                                                {/* Home Button */}
                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link btn-sm"
                                                        onClick={() => setCurrentPage(1)}
                                                        style={{
                                                            borderColor: '#31a87e',
                                                            backgroundColor: 'white',
                                                            color: '#31a87e',
                                                            padding: '5px 10px',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        &laquo; {/* << Icon */}
                                                    </button>
                                                </li>

                                                {/* Previous Button */}
                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link btn-sm"
                                                        onClick={() => setCurrentPage(currentPage - 1)}
                                                        style={{
                                                            borderColor: '#31a87e',
                                                            backgroundColor: 'white',
                                                            color: '#31a87e',
                                                            padding: '5px 10px',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        &lt; {/* < Icon */}
                                                    </button>
                                                </li>

                                                {/* Current Page */}
                                                <li className="page-item active">
                                                    <button
                                                        className="page-link btn-sm"
                                                        style={{
                                                            backgroundColor: '#31a87e',
                                                            color: 'white',
                                                            borderColor: '#31a87e',
                                                            padding: '5px 10px',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        {currentPage}
                                                    </button>
                                                </li>

                                                {/* Next Button */}
                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link btn-sm"
                                                        onClick={() => setCurrentPage(currentPage + 1)}
                                                        style={{
                                                            borderColor: '#31a87e',
                                                            backgroundColor: 'white',
                                                            color: '#31a87e',
                                                            padding: '5px 10px',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        &gt; {/* > Icon */}
                                                    </button>
                                                </li>

                                                {/* End Button */}
                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                    <button
                                                        className="page-link btn-sm"
                                                        onClick={() => setCurrentPage(totalPages)}
                                                        style={{
                                                            borderColor: '#31a87e',
                                                            backgroundColor: 'white',
                                                            color: '#31a87e',
                                                            padding: '5px 10px',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        &raquo; {/* >> Icon */}
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <Footer />
                <ToastContainer 
                    position="top-center" 
                    autoClose={3000} 
                    hideProgressBar={false} 
                    newestOnTop={false} 
                    closeOnClick rtl={true} 
                    pauseOnFocusLoss 
                    draggable 
                    pauseOnHover />
            </div>
        </>
    );
};

export default ViewDeliveryAgentEarnings;
